import { DeliveryComponent } from "./delivery/delivery.component";
import { Component, ViewChild, HostListener } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import {
  Idle,
  DEFAULT_INTERRUPTSOURCES,
} from "../../node_modules/@ng-idle/core";
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { environment } from "../environments/environment";
import { authConfig } from "./authorization/authorization.config";
import { DataService } from "./shared/services/data.service";
import { ValidationMessage } from "./shared/constant";
import { Router } from "@angular/router";
import { AlertPopupComponent } from "./alert-popup/alert-popup.component";
import { MatSidenav } from "@angular/material/sidenav";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "RateTables";
  screenWidth: number;
  isMenuOpen: boolean = false;
  default: boolean = false;

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private dialog: MatDialog,
    private _dataService: DataService,
    private idle: Idle
  ) {
    window.addEventListener("beforeunload", function (e) {
      localStorage.setItem(
        "referesh_event_flag",
        new Date().getTime().toString()
      );
      let rate_table_id = localStorage.getItem("rate_table_id");
      if (
        localStorage.getItem("IsDirectUser") == "Yes" &&
        localStorage.getItem("email").length > 0 &&
        rate_table_id == null
      ) {
        localStorage.clear();
      }
    });
    this.screenWidth = window.innerWidth;
    localStorage.getItem("referesh_event_flag");
    var t0 = Number(localStorage.getItem("referesh_event_flag"));
    if (isNaN(t0)) t0 = 0;
    var t1 = new Date().getTime();
    var duration = t1 - t0;
    if (duration > 10 * 1000) {
      // greater than 10 seconds since the previous Unload event
      let redirectUrl = localStorage.getItem("redirectUrl");
      let isDirectUser = localStorage.getItem("IsDirectUser");
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem(
        "referesh_event_flag",
        new Date().getTime().toString()
      );
      if (
        redirectUrl != null &&
        redirectUrl != undefined &&
        redirectUrl != ""
      ) {
        localStorage.setItem("redirectUrl", redirectUrl);
      }
      if (
        isDirectUser != null &&
        isDirectUser != undefined &&
        isDirectUser != ""
      ) {
        localStorage.setItem("IsDirectUser", isDirectUser);
      }
    }
    this.saveGroupInfo();
    this.ClientAuthenticationWithSecureAccess();
    if (environment.apiEndPoints.enableCSP) {
      this.loadContentSecurityPolicyScript();
    }
  }
  // allow keys these to be saved to localStorage, ignore any others (for security purposes)
  acceptableKeys = [
    // for broker mobile app
    "bma",
    // for Quote Lite
    "redirectUrl",
    // keys below are for WB Quote
    "group_id",
    "broker_id",
    "broker_state",
    "salesRepName",
    "broker_name",
    "broker_LicenseNumber",
    "broker_Phone",
    "salesRepEmail",
    "email",
    "impersonated",
    "impersonateUserId"
  ];

  saveGroupInfo() {
    var qs =
      window.location.hash != ""
        ? window.location.hash
        : window.location.search;

    // ignore the '#code' part
    if (qs.startsWith("#")) {
      qs = qs.replace(/^#.+\?/, "");
    }

    let tokens = qs.split(/[?&]/);

    if (qs == "" || tokens.length == 0) {
      localStorage.setItem("IsDirectUser", "Yes");
      localStorage.setItem("FromApp", "direct");
      return;
    }

    localStorage.setItem("IsDirectUser", "No");

    let keyProcessed = 0;
    tokens.forEach((v, i) => {
      let kv = v.split("=");
      if (kv.length < 2) return;

      let key = kv[0];
      let keyup = key.toUpperCase();
      let value = kv[1];

      let match = false;
      this.acceptableKeys.forEach((v, i) => {
        if (v.toUpperCase() == keyup) match = true;
      });
      if (!match) return;

      keyProcessed++;
      // --------------------------------
      // process keys from BMA
      // --------------------------------
      if (keyup == "BMA") {
        if (value === "1") localStorage.setItem("isBma", value);
        localStorage.setItem("FromApp", "bma");
        this.setUserAcceptedDisclaimerAgreement();
        return;
      }

      // --------------------------------
      // process keys from QuoteLite
      // --------------------------------
      if (keyup == "REDIRECTURL") {
        const regex = new RegExp(
          "(http(s)?://((.+.)?(www\\.)?wordandbrown.com|(.+.)?localhost:d+))"
        );
        const redirectURL = value + "/";
        localStorage.setItem(
          key,
          regex.test(redirectURL) ? redirectURL : environment.wbQuoteLiteUri
        );
        localStorage.setItem("FromApp", "quotelite");
        this.setUserAcceptedDisclaimerAgreement();
        return;
      }

      // --------------------------------
      // process keys from WBQuote
      // --------------------------------

      localStorage.setItem(key, value);
      localStorage.setItem("IsFromWBQuote", "Yes");
      localStorage.setItem("FromApp", "wbquote");
      this.setUserAcceptedDisclaimerAgreement();
    });

    if (keyProcessed == 0) {
      localStorage.setItem("IsDirectUser", "Yes");
      localStorage.setItem("FromApp", "direct");
    }
  }

  private setUserAcceptedDisclaimerAgreement() {
    // user has already agreed on the disclaimer (via the transferring website)
    // set this so the unsupported browser can be triggered.
    localStorage.setItem("IsTermsAccepted", "true");
    this._dataService.IsTermsAccepted = true;
  }

  @HostListener("window:resize", ["$event"])
  reSize(event) {
    this.screenWidth = window.innerWidth;
  }

  private ClientAuthenticationWithSecureAccess() {
    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    // this.oauthService.setStorage(localStorage);

    this.oauthService.loadDiscoveryDocument().then((doc) => {
      this.oauthService
        .tryLogin()
        .catch((err) => {
          console.error(err);
        })
        .then(() => {
          if (
            !this.oauthService.hasValidIdToken() ||
            !this.oauthService.hasValidAccessToken()
          ) {
            this.oauthService.initImplicitFlow();
          }
        });
    });

    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.events.subscribe((e) => {
      console.debug("oauth/oidc event", e);
    });
    
    this.oauthService.events
      .pipe(
        filter((e) => ["session_terminated", "session_error"].includes(e.type))
      )
      .subscribe((e) => {
        console.log("Your session has been terminated!");
        sessionStorage.clear();
        window.location.href = environment.apiEndPoints.SingleSignoutRedirect;
      });

    // this.oauthService.events.filter(e => e.type === 'session_terminated').subscribe(e => {
    //    console.debug('Your session has been terminated!');
    //  });
  }
  private ConfigureUserIdleState() {
    this.idle.setIdle(environment.idleTime);

    this.idle.setTimeout(environment.idleTimeout);

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      this.displayAlertPopUp();
    });

    this.idle.onIdleEnd.subscribe(() => {
      console.log("IdleEnd");
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      console.log("TimeoutWarning: " + countdown);
    });

    this.idle.onTimeout.subscribe(() => {
      console.log("Timeout");

      this._dataService.redirect();
    });

    // start watching for idleness right away.
    this.idle.watch();
  }
  addNoScrollBackground() {
    this.isMenuOpen = true;
  }

  removeNoScrollBackground() {
    this.isMenuOpen = false;
  }
  displayAlertPopUp() {
    this.dialog.open(AlertPopupComponent, {
      width: "250px",
      autoFocus: false,
      data: {
        title: ValidationMessage.alertMessage,
        Message: ValidationMessage.IdleSession,
        showCancelButton: true,
      },
    });
  }
  getParmas(params): any {
    //Retrun URL always be on firstURl
    let redirectUrl = "";
    if (params && params[0] != "") {
      var a = params[0].split("=");
      if (a.indexOf("redirectUrl") > -1 && a.length == 2) {
        params = params[0].slice(0, 0);
        localStorage.setItem("redirectUrl", a[1]);
      } else {
        localStorage.setItem("redirectUrl", "");
      }
    }
    return params;
  }

  public loadContentSecurityPolicyScript(): void {
    const cspScriptPolicy =
      "object-src " +
      `${environment.apiEndPoints.cspObjectSrc}` +
      "connect-src " +
      `${environment.apiEndPoints.cspConnectSrc}` +
      "font-src " +
      `${environment.apiEndPoints.cspFontSrc}` +
      "frame-src " +
      `${environment.apiEndPoints.cspFrameSrc}` +
      "img-src " +
      `${environment.apiEndPoints.cspImgSrc}` +
      "media-src " +
      `${environment.apiEndPoints.cspMediaSrc}` +
      "script-src " +
      `${environment.apiEndPoints.cspScriptSrc}` +
      "style-src " +
      `${environment.apiEndPoints.cspStyleSrc}` +
      "require-trusted-types-for " +
      `${environment.apiEndPoints.cspRequireTrustedTypesFor}`;
    //setTimeout(() => {
    // Inject a <meta> tag
    console.log(cspScriptPolicy);
    var cspMetaTag = document.createElement("meta");
    cspMetaTag.setAttribute("http-equiv", "Content-Security-Policy");
    cspMetaTag.setAttribute("content", cspScriptPolicy);
    document.getElementsByTagName("head")[0].appendChild(cspMetaTag);
    //}, 3000);
  }
}

declare global {
  interface Navigator {
    msSaveOrOpenBlob(blob: any, defaultName?: string): boolean;
  }
}
